/* eslint-disable no-useless-concat */
import axios from "axios";
import Config from "../../config";

import {
  callNotification,
  setCookie,
  sessionExpired,
  getUTCOffset,
} from "../constants";
import { setGlobalLoader, setTemplateListLoader } from "./ApiCall/apiCall";
import { setTemporaryWords } from "./Attribute";
import {
  setGlobalBrands,
  setGlobalDuration,
  setGlobalSingleBrands,
} from "./AuthParams";
import { onDashboardReset } from "./dashboard/Tab1";
import { handleApiError, handleAxiosError } from "../utils/errorHandler";

function deleteAllCookies() {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

export const setAuth = (token, user_id) => {
  const d = new Date();
  let utcOffset = d.getTimezoneOffset();
  return async (dispatch) => {
    let body = {
      appid: parseInt(Config.config1.app_id),
      userid: parseInt(user_id),
      temp_token: token,
      consumer_key: Config.config1.consumer_key,
      utcoffset: utcOffset,
    };

    // Custom error handlers for authentication API
    const customErrorHandlers = {
      // 9: (errorCodeValue, errorMessage, response, dispatch) => {
      //   // Session expired - use existing session management
      //   sessionExpired(true);
      //   callNotification(errorMessage, "error");
      // },
      default: (errorCodeValue, errorMessage, response, dispatch) => {
        // Default error handling for other error codes including 21
        callNotification(errorMessage, "error");
      },
    };

    let url = `${Config.config1.api_link}/user/oauth`;
    axios
      .post(url, body)
      .then((response) => {
        dispatch({
          type: "SET_OAUTH",
          payload: response,
        });
        if (response?.data?.status === "successful") {
          setCookie("ptoken", response?.data?.result?.ptoken);
          setCookie("userid", response?.data?.result?.userid);
        } else if (response?.data?.status === "error") {
          handleApiError(response, dispatch, { customErrorHandlers });
        }
      })
      .catch((error) => {
        handleAxiosError(error, dispatch, { customErrorHandlers });
      });
  };
};

//setting report id
export const setReportId = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_REPORT_ID", payload: value });
  };
};

//setting auth loader
export const setAuthLoader = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_AUTH_LOADER", payload: value });
  };
};

//setting auth flag
export const setAuthFlag = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_AUTH_FLAG", payload: value });
  };
};

export const setEnableAWA = (ptoken, user_id) => {
  return async (dispatch) => {
    let body = {
      user_id: user_id,
      ptoken: ptoken,
      utcoffset: getUTCOffset(),
    };

    let url = `${Config.config1.api_link}/enable_awa`;
    axios
      .post(url, body)
      .then((response) => {
        dispatch({
          type: "SET_ENABLE_AWA",
          payload: response,
        });
        if (response?.data?.status === "successful") {
          callNotification("Your request has been submitted!", "success");
        } else if (response?.data?.status === "error") {
          handleApiError(response, dispatch);
        }
      })
      .catch((error) => {
        handleAxiosError(error, dispatch);
      });
  };
};

//sign out function
export const setSignOut = (ptoken, user_id) => {
  return async (dispatch) => {
    let body = {
      user_id: user_id,
      ptoken: ptoken,
      utcoffset: getUTCOffset(),
    };

    // Custom error handlers for sign out API
    const customErrorHandlers = {
      9: (errorCodeValue, errorMessage, response, dispatch) => {
        // Session expired - still proceed with logout cleanup
        sessionExpired(true);
        callNotification(errorMessage, "error");
        dispatch(setGlobalLoader(false));
      },
      default: (errorCodeValue, errorMessage, response, dispatch) => {
        // Default error handling for other error codes including 21
        callNotification(errorMessage, "error");
        dispatch(setGlobalLoader(false));
      },
    };

    let url = `${Config.config1.api_link}/user/logout`;
    dispatch(setGlobalLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        dispatch(setGlobalLoader(false));
        if (response?.data?.status === "successful") {
          dispatch({
            type: "SET_SIGN_OUT",
            payload: response,
          });
          deleteAllCookies();

          // reset all states
          dispatch(setGlobalDuration(null));
          dispatch(setGlobalBrands(null));
          dispatch(setGlobalSingleBrands(null));
          dispatch(onDashboardReset());
          dispatch(setTemporaryWords({}));
          window.localStorage.clear();
        } else if (response?.data?.status === "error") {
          handleApiError(response, dispatch, { customErrorHandlers });
        }
      })
      .catch((error) => {
        dispatch(setGlobalLoader(false));
        handleAxiosError(error, dispatch, { customErrorHandlers });
      });
  };
};

//Check Login status
export const setLoginStatus = (ptoken, user_id) => {
  return async (dispatch) => {
    if (ptoken) {
      let body = {
        //user_id: parseInt(user_id),
        ptoken: ptoken,
        utcoffset: getUTCOffset(),
      };

      // Custom error handlers for login status API
      const customErrorHandlers = {
        default: (errorCodeValue, errorMessage, response, dispatch) => {
          // Default error handling for other error codes including 21
          callNotification(errorMessage, "error");
        },
      };

      let url = `${Config.config1.api_link}/user/login/status`;
      axios
        .post(url, body)
        .then((response) => {
          if (response?.data?.status === "successful") {
          } else if (response?.data?.status === "error") {
          }
          dispatch({
            type: "SET_LOGIN_STATUS",
            payload: response,
          });
        })
        .catch((error) => {
          handleAxiosError(error, dispatch, { customErrorHandlers });
        });
    } else {
      dispatch({
        type: "SET_LOGIN_STATUS",
        payload: null,
      });
    }
  };
};
